import {AlertType} from 'src/openapi/admin/models/AlertType';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

export const ALERT_TYPE_CAPTIONS = {
    [AlertType.SHOW_EVERY_LOGIN]: 'Show every login',
    [AlertType.SHOW_ONCE]: 'Only at first login',
    [AlertType.SHOW_UNTIL_CLOSED]: 'Until user exits alert',
};

export const platformAlertTypes: DictionaryItem[] = [
    {
        code: AlertType.SHOW_EVERY_LOGIN,
        description: ALERT_TYPE_CAPTIONS[AlertType.SHOW_EVERY_LOGIN],
    },
    {
        code: AlertType.SHOW_ONCE,
        description: ALERT_TYPE_CAPTIONS[AlertType.SHOW_ONCE],
    },
    {
        code: AlertType.SHOW_UNTIL_CLOSED,
        description: ALERT_TYPE_CAPTIONS[AlertType.SHOW_UNTIL_CLOSED],
    },
];

export const MAX_HTML_LENGTH = 5000;

export const ALERT_MESSAGE_CONTROL = 'alert-message-control';
export const ALERT_MESSAGE_REQUIRED_ERROR = 'alert-message-required-error';
export const ALERT_MESSAGE_REQUIRED_MESSAGE = 'Message is required field';
export const ALERT_MESSAGE_HTML_TOO_LONG_ERROR = 'alert-message-too-long-error';
export const ALERT_MESSAGE_HTML_TOO_LONG_MESSAGE = 'The length of Source html is more then 2000 characters allowed';

export const ALERT_ACCOUNT_CONTROL = 'alert-account-control';
export const ALERT_ACCOUNT_REQUIRED_ERROR = 'alert-account-required-error';
export const ALERT_ACCOUNT_REQUIRED_MESSAGE = 'Account is required field';

export const ALERT_START_DATE_CONTROL = 'alert-start-date-control';
export const ALERT_START_DATE_REQUIRED_ERROR = 'alert-start-date-required-error';
export const ALERT_START_DATE_REQUIRED_MESSAGE = 'Start date is required field';

export const ALERT_END_DATE_CONTROL = 'alert-end-date-control';
export const ALERT_END_DATE_REQUIRED_ERROR = 'alert-end-date-required-error';
export const ALERT_END_DATE_REQUIRED_MESSAGE = 'End date is required field';
export const ALERT_START_BEFORE_END_DATE_ERROR = 'alert-start-before-end-date-error';
export const ALERT_START_BEFORE_END_DATE_MESSAGE = 'Alert end date cannot be before the start date';
export const ALERT_END_TIME_CONTROL = 'alert-start-time-before-end-time-control';
export const ALERT_END_TIME_BEFORE_START_TIME_ERROR = 'alert-start-time-before-end-time-error';
export const ALERT_END_TIME_BEFORE_START_TIME_MESSAGE = 'Alert end time cannot be before the start time';
